import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let brandsPromise = null;
function getBrandsCached() {
  if (!brandsPromise) brandsPromise = api.get("/brands").then((res) => res.data).catch(() => []);
  return brandsPromise;
}

export function useBrandLogos() {
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    getBrandsCached().then(setBrands);
  }, []);

  const logoFor = (slug, variant = "black") => {
    const b = brands.find((x) => x.slug === slug);
    const path = variant === "white" ? b?.logo_url_white : b?.logo_url_black;
    return path ? `${process.env.REACT_APP_BACKEND_URL}${path}` : null;
  };

  return { brands, logoFor };
}
